export const VIEWPORT_CONTENT =
  "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover";

export function enforceViewport() {
  if (typeof document === "undefined") return;

  const metas = document.querySelectorAll('meta[name="viewport"]');
  if (metas.length === 0) {
    const meta = document.createElement("meta");
    meta.setAttribute("name", "viewport");
    meta.setAttribute("content", VIEWPORT_CONTENT);
    document.head.appendChild(meta);
    return;
  }

  metas[0].setAttribute("content", VIEWPORT_CONTENT);
  for (let i = 1; i < metas.length; i += 1) {
    metas[i].parentNode?.removeChild(metas[i]);
  }
}
